/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Access_PeriodInputs */

const en_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Period`)
};

const es_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período de acceso`)
};

const fr_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période d'accès`)
};

const de_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffszeitraum`)
};

const ja_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセス可能期間`)
};

const zh_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问期限`)
};

const ar_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فترة الوصول`)
};

const id_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periode Akses`)
};

const it_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo di Accesso`)
};

const ru_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок доступа`)
};

const pt_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período de Acesso`)
};

const ko_field_access_period = /** @type {(inputs: Field_Access_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수강/접근 기간`)
};

/**
* | output |
* | --- |
* | "Access Period" |
*
* @param {Field_Access_PeriodInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_access_period = /** @type {((inputs?: Field_Access_PeriodInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Access_PeriodInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_access_period(inputs)
	if (locale === "es") return es_field_access_period(inputs)
	if (locale === "fr") return fr_field_access_period(inputs)
	if (locale === "de") return de_field_access_period(inputs)
	if (locale === "ja") return ja_field_access_period(inputs)
	if (locale === "zh") return zh_field_access_period(inputs)
	if (locale === "ar") return ar_field_access_period(inputs)
	if (locale === "id") return id_field_access_period(inputs)
	if (locale === "it") return it_field_access_period(inputs)
	if (locale === "ru") return ru_field_access_period(inputs)
	if (locale === "pt") return pt_field_access_period(inputs)
	return ko_field_access_period(inputs)
});